import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/longPartner/home/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/longPartner/home'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/longPartner/introduction/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/longPartner/introduction',
    meta: {
      title: ''
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/longPartner/levelRule/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/longPartner/levelRule',
    meta: {
      title: '等级规则'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/longPartner/blessingValue/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/longPartner/blessingValue',
    meta: {
      title: '福气值记录'
    }
  }
]
